// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"VR","modalTitleContainer":"WR","addressTitleSection":"XR"};